import { useState } from 'react'
import { useT } from './i18n-context.js'

/**
 * Код персонажа с копированием одним касанием (D29).
 *
 * Код диктуют голосом, но чаще пересылают, — поэтому кнопка. Само
 * копирование делает браузер (`navigator.clipboard`), и оно может
 * не сработать: буфер обмена требует безопасного контекста
 * и разрешения. Код при этом остаётся на экране и выделяется руками:
 * кнопка — ускорение, а не единственный путь.
 *
 * Подтверждение показывается на месте кнопки и не исчезает по таймеру:
 * исчезающее сообщение читают не все и не всегда.
 */
export function CharacterCode({ code }: { readonly code: string }) {
  const t = useT()
  const [copied, setCopied] = useState(false)

  const copy = () => {
    void navigator.clipboard
      ?.writeText(code)
      .then(() => {
        setCopied(true)
      })
      .catch(() => {
        // Буфер недоступен: код на экране, копировать можно руками.
      })
  }

  return (
    <p className="app-code" data-testid="character-code">
      <span className="app-code-label">{t('sheet.code')}</span>
      {/* Засечный набор и разрядка: код читают по знакам, а не словом. */}
      <output className="app-code-value">{code}</output>
      <button
        type="button"
        className="app-button app-button-quiet"
        onClick={copy}
        aria-live="polite"
      >
        {copied ? t('sheet.codeCopied') : t('sheet.copyCode')}
      </button>
    </p>
  )
}
